var map = {
	"./Base/blackboard.png": 37447,
	"./Base/wood.png": 73531,
	"./ObstacleGame/Tech@2x.png": 8442,
	"./ObstacleGame/default.png": 18655,
	"./app-updates.png": 31634,
	"./chatbot/ai-tutor-button.png": 54676,
	"./chatbot/ai-tutor-character.png": 50871,
	"./chatbot/classroom.png": 27611,
	"./chatbot/course.png": 5195,
	"./chatbot/heijaijai-lineat-qrcode.png": 49451,
	"./chatbot/high-intensity.png": 38224,
	"./chatbot/learn.png": 49708,
	"./chatbot/location.png": 41998,
	"./chatbot/low-intensity.png": 19580,
	"./chatbot/moderate-intensity.png": 42271,
	"./chatbot/others.png": 60733,
	"./chatbot/question.png": 13332,
	"./chatbot/recommend.png": 21628,
	"./chatbot/resend.png": 9793,
	"./chatbot/verification.png": 58897,
	"./chatbot/vip.png": 40155,
	"./common/completed.png": 67817,
	"./common/default-avatar.png": 88743,
	"./common/default-video-img.png": 6901,
	"./common/versus.png": 74278,
	"./game/ai-black.png": 35459,
	"./game/ai-white.png": 99757,
	"./guide-img.png": 58992,
	"./hjj-AiCourse/hjjAicourse-1.png": 56146,
	"./hjj-AiCourse/hjjAicourse-2.png": 4329,
	"./hjj-AiCourse/hjjAicourse-3.png": 80128,
	"./home/mask_1.png": 77874,
	"./home/mask_2.png": 43017,
	"./home/mask_3.png": 88192,
	"./home/mask_4.png": 46847,
	"./home/verification-card-desktop.png": 98387,
	"./home/verification-card-mobile.png": 13109,
	"./horizontal_logo.png": 14884,
	"./icon/lets go.png": 90558,
	"./ladder/background.png": 76733,
	"./learn-plan/entry-1.png": 37709,
	"./locales/en-US/guide/live-course-guide.png": 87927,
	"./locales/en-US/guide/notification-guide.png": 72192,
	"./locales/en-US/live-course/card-preview.png": 28159,
	"./locales/en-US/login/web_login_1_tc.png": 41003,
	"./locales/en-US/login/web_login_2_tc.png": 73002,
	"./locales/en-US/login/web_login_3_tc.png": 24949,
	"./locales/en-US/login/web_login_banner.png": 96770,
	"./locales/en-US/personal/certificate.png": 48549,
	"./locales/en-US/personal/g_certificate.png": 95551,
	"./locales/en-US/pvp/event-double-elo.png": 75995,
	"./locales/en-US/sticker/bubu-1.png": 8995,
	"./locales/en-US/sticker/bubu-2.png": 72136,
	"./locales/en-US/sticker/bubu-3.png": 12081,
	"./locales/en-US/sticker/bubu-4.png": 75966,
	"./locales/en-US/sticker/bubu-5.png": 63655,
	"./locales/en-US/sticker/bubu-6.png": 78828,
	"./locales/en-US/sticker/bubu-7.png": 61717,
	"./locales/en-US/sticker/bubu-8.png": 9714,
	"./locales/en-US/sticker/bubu-9.png": 75067,
	"./locales/en-US/sticker/hjj-1.png": 36655,
	"./locales/en-US/sticker/hjj-2.png": 14196,
	"./locales/en-US/sticker/hjj-3.png": 35325,
	"./locales/en-US/sticker/hjj-4.png": 42530,
	"./locales/en-US/sticker/hjj-5.png": 89835,
	"./locales/en-US/sticker/hjj-6.png": 24432,
	"./locales/en-US/sticker/hjj-7.png": 56537,
	"./locales/en-US/sticker/hjj-8.png": 24622,
	"./locales/en-US/sticker/hjj-9.png": 98263,
	"./locales/en-US/verification/verification-shield.png": 93464,
	"./locales/ja-JP/guide/live-course-guide.png": 12695,
	"./locales/ja-JP/guide/notification-guide.png": 6656,
	"./locales/ja-JP/live-course/card-preview.png": 28671,
	"./locales/ja-JP/login/web_login_1_tc.png": 96299,
	"./locales/ja-JP/login/web_login_2_tc.png": 79722,
	"./locales/ja-JP/login/web_login_3_tc.png": 37365,
	"./locales/ja-JP/login/web_login_banner.png": 20162,
	"./locales/ja-JP/personal/certificate.png": 44133,
	"./locales/ja-JP/personal/g_certificate.png": 1471,
	"./locales/ja-JP/pvp/event-double-elo.png": 60827,
	"./locales/ja-JP/sticker/bubu-1.png": 93891,
	"./locales/ja-JP/sticker/bubu-2.png": 8616,
	"./locales/ja-JP/sticker/bubu-3.png": 6481,
	"./locales/ja-JP/sticker/bubu-4.png": 65470,
	"./locales/ja-JP/sticker/bubu-5.png": 83783,
	"./locales/ja-JP/sticker/bubu-6.png": 63724,
	"./locales/ja-JP/sticker/bubu-7.png": 32821,
	"./locales/ja-JP/sticker/bubu-8.png": 3666,
	"./locales/ja-JP/sticker/bubu-9.png": 17883,
	"./locales/ja-JP/sticker/hjj-1.png": 46063,
	"./locales/ja-JP/sticker/hjj-2.png": 71572,
	"./locales/ja-JP/sticker/hjj-3.png": 4605,
	"./locales/ja-JP/sticker/hjj-4.png": 354,
	"./locales/ja-JP/sticker/hjj-5.png": 21483,
	"./locales/ja-JP/sticker/hjj-6.png": 50192,
	"./locales/ja-JP/sticker/hjj-7.png": 56441,
	"./locales/ja-JP/sticker/hjj-8.png": 24526,
	"./locales/ja-JP/sticker/hjj-9.png": 70103,
	"./locales/ja-JP/verification/verification-shield.png": 86360,
	"./locales/zh-CN/guide/live-course-guide.png": 96789,
	"./locales/zh-CN/guide/notification-guide.png": 65414,
	"./locales/zh-CN/live-course/card-preview.png": 5701,
	"./locales/zh-CN/login/web_login_1_tc.png": 83601,
	"./locales/zh-CN/login/web_login_2_tc.png": 55236,
	"./locales/zh-CN/login/web_login_3_tc.png": 79271,
	"./locales/zh-CN/login/web_login_banner.png": 47072,
	"./locales/zh-CN/personal/certificate.png": 76803,
	"./locales/zh-CN/personal/g_certificate.png": 4277,
	"./locales/zh-CN/pvp/event-double-elo.png": 77281,
	"./locales/zh-CN/sticker/bubu-1.png": 54881,
	"./locales/zh-CN/sticker/bubu-2.png": 13802,
	"./locales/zh-CN/sticker/bubu-3.png": 29363,
	"./locales/zh-CN/sticker/bubu-4.png": 31964,
	"./locales/zh-CN/sticker/bubu-5.png": 84229,
	"./locales/zh-CN/sticker/bubu-6.png": 56398,
	"./locales/zh-CN/sticker/bubu-7.png": 55895,
	"./locales/zh-CN/sticker/bubu-8.png": 39536,
	"./locales/zh-CN/sticker/bubu-9.png": 45785,
	"./locales/zh-CN/sticker/hjj-1.png": 6993,
	"./locales/zh-CN/sticker/hjj-2.png": 2234,
	"./locales/zh-CN/sticker/hjj-3.png": 49987,
	"./locales/zh-CN/sticker/hjj-4.png": 90092,
	"./locales/zh-CN/sticker/hjj-5.png": 26005,
	"./locales/zh-CN/sticker/hjj-6.png": 40254,
	"./locales/zh-CN/sticker/hjj-7.png": 92743,
	"./locales/zh-CN/sticker/hjj-8.png": 91648,
	"./locales/zh-CN/sticker/hjj-9.png": 69769,
	"./locales/zh-CN/verification/verification-shield.png": 23530,
	"./locales/zh-TW/guide/live-course-guide.png": 13941,
	"./locales/zh-TW/guide/notification-guide.png": 44966,
	"./locales/zh-TW/live-course/card-preview.png": 85253,
	"./locales/zh-TW/login/web_login_1_tc.png": 61649,
	"./locales/zh-TW/login/web_login_2_tc.png": 33284,
	"./locales/zh-TW/login/web_login_3_tc.png": 57319,
	"./locales/zh-TW/login/web_login_banner.png": 80000,
	"./locales/zh-TW/personal/certificate.png": 54851,
	"./locales/zh-TW/personal/g_certificate.png": 37205,
	"./locales/zh-TW/pvp/event-double-elo.png": 55329,
	"./locales/zh-TW/sticker/bubu-1.png": 49281,
	"./locales/zh-TW/sticker/bubu-2.png": 91850,
	"./locales/zh-TW/sticker/bubu-3.png": 23763,
	"./locales/zh-TW/sticker/bubu-4.png": 26364,
	"./locales/zh-TW/sticker/bubu-5.png": 62277,
	"./locales/zh-TW/sticker/bubu-6.png": 50798,
	"./locales/zh-TW/sticker/bubu-7.png": 50295,
	"./locales/zh-TW/sticker/bubu-8.png": 33936,
	"./locales/zh-TW/sticker/bubu-9.png": 40185,
	"./locales/zh-TW/sticker/hjj-1.png": 86769,
	"./locales/zh-TW/sticker/hjj-2.png": 65658,
	"./locales/zh-TW/sticker/hjj-3.png": 29763,
	"./locales/zh-TW/sticker/hjj-4.png": 53516,
	"./locales/zh-TW/sticker/hjj-5.png": 5781,
	"./locales/zh-TW/sticker/hjj-6.png": 20030,
	"./locales/zh-TW/sticker/hjj-7.png": 72519,
	"./locales/zh-TW/sticker/hjj-8.png": 71424,
	"./locales/zh-TW/sticker/hjj-9.png": 49545,
	"./locales/zh-TW/verification/verification-shield.png": 73898,
	"./login/Apple.png": 6756,
	"./login/Google.png": 42411,
	"./login/Line.png": 55740,
	"./login/base-logo-white.png": 87385,
	"./login/countdown_bg.png": 52903,
	"./login/countdown_ellipse.png": 69854,
	"./login/countdown_hjj.png": 88168,
	"./login/login-bg-bottom.png": 67511,
	"./login/login-bg-top.png": 80413,
	"./logo.png": 65549,
	"./modal/awesome.png": 33925,
	"./modal/complete.png": 79123,
	"./modal/frustration.png": 73893,
	"./modal/get-coupon.png": 71973,
	"./modal/handclap.png": 9711,
	"./modal/ok.png": 19620,
	"./multimediaClassroom/shortcut1.png": 41574,
	"./multimediaClassroom/shortcut2.png": 25341,
	"./multimediaClassroom/shortcut3.png": 4212,
	"./multimediaClassroom/shortcut4.png": 96203,
	"./offline.png": 267,
	"./personal/avatar/0000.png": 61891,
	"./personal/avatar/0001.png": 44314,
	"./personal/avatar/0002.png": 74481,
	"./personal/avatar/0003.png": 76616,
	"./personal/avatar/0004.png": 51783,
	"./personal/avatar/0005.png": 33470,
	"./personal/avatar/0006.png": 821,
	"./personal/avatar/0007.png": 31724,
	"./personal/avatar/0008.png": 69531,
	"./personal/avatar/0009.png": 71666,
	"./personal/avatar/0010.png": 11640,
	"./personal/avatar/0011.png": 79905,
	"./personal/avatar/0012.png": 30922,
	"./personal/avatar/0013.png": 86131,
	"./personal/avatar/0014.png": 2524,
	"./personal/avatar/ai_b.png": 63538,
	"./personal/avatar/ai_w.png": 32463,
	"./personal/avatar/avatar_none.png": 89483,
	"./personal/avatar/avatar_tsumego_ai_1-kid.png": 35095,
	"./personal/avatar/avatar_tsumego_ai_1.png": 7260,
	"./personal/avatar/avatar_tsumego_ai_10-kid.png": 41461,
	"./personal/avatar/avatar_tsumego_ai_10.png": 7046,
	"./personal/avatar/avatar_tsumego_ai_100.png": 29204,
	"./personal/avatar/avatar_tsumego_ai_101.png": 50333,
	"./personal/avatar/avatar_tsumego_ai_102.png": 69126,
	"./personal/avatar/avatar_tsumego_ai_103.png": 50671,
	"./personal/avatar/avatar_tsumego_ai_104.png": 65296,
	"./personal/avatar/avatar_tsumego_ai_105.png": 71545,
	"./personal/avatar/avatar_tsumego_ai_106.png": 4962,
	"./personal/avatar/avatar_tsumego_ai_107.png": 79115,
	"./personal/avatar/avatar_tsumego_ai_108.png": 74076,
	"./personal/avatar/avatar_tsumego_ai_109.png": 9989,
	"./personal/avatar/avatar_tsumego_ai_11-kid.png": 89332,
	"./personal/avatar/avatar_tsumego_ai_11.png": 68444,
	"./personal/avatar/avatar_tsumego_ai_110.png": 79455,
	"./personal/avatar/avatar_tsumego_ai_111.png": 82518,
	"./personal/avatar/avatar_tsumego_ai_112.png": 96493,
	"./personal/avatar/avatar_tsumego_ai_113.png": 42596,
	"./personal/avatar/avatar_tsumego_ai_114.png": 6459,
	"./personal/avatar/avatar_tsumego_ai_115.png": 91634,
	"./personal/avatar/avatar_tsumego_ai_116.png": 22601,
	"./personal/avatar/avatar_tsumego_ai_117.png": 28128,
	"./personal/avatar/avatar_tsumego_ai_118.png": 29223,
	"./personal/avatar/avatar_tsumego_ai_119.png": 76734,
	"./personal/avatar/avatar_tsumego_ai_12-kid.png": 49311,
	"./personal/avatar/avatar_tsumego_ai_12.png": 10804,
	"./personal/avatar/avatar_tsumego_ai_120.png": 57454,
	"./personal/avatar/avatar_tsumego_ai_121.png": 471,
	"./personal/avatar/avatar_tsumego_ai_122.png": 16188,
	"./personal/avatar/avatar_tsumego_ai_123.png": 29253,
	"./personal/avatar/avatar_tsumego_ai_124.png": 60938,
	"./personal/avatar/avatar_tsumego_ai_125.png": 99795,
	"./personal/avatar/avatar_tsumego_ai_126.png": 25304,
	"./personal/avatar/avatar_tsumego_ai_127.png": 9921,
	"./personal/avatar/avatar_tsumego_ai_128.png": 53766,
	"./personal/avatar/avatar_tsumego_ai_129.png": 92783,
	"./personal/avatar/avatar_tsumego_ai_13-kid.png": 59014,
	"./personal/avatar/avatar_tsumego_ai_13.png": 31933,
	"./personal/avatar/avatar_tsumego_ai_130.png": 76041,
	"./personal/avatar/avatar_tsumego_ai_131.png": 21216,
	"./personal/avatar/avatar_tsumego_ai_132.png": 99547,
	"./personal/avatar/avatar_tsumego_ai_133.png": 85330,
	"./personal/avatar/avatar_tsumego_ai_134.png": 57837,
	"./personal/avatar/avatar_tsumego_ai_135.png": 17892,
	"./personal/avatar/avatar_tsumego_ai_136.png": 72543,
	"./personal/avatar/avatar_tsumego_ai_137.png": 76214,
	"./personal/avatar/avatar_tsumego_ai_138.png": 88145,
	"./personal/avatar/avatar_tsumego_ai_139.png": 90280,
	"./personal/avatar/avatar_tsumego_ai_14-kid.png": 81057,
	"./personal/avatar/avatar_tsumego_ai_14.png": 35586,
	"./personal/avatar/avatar_tsumego_ai_140.png": 69752,
	"./personal/avatar/avatar_tsumego_ai_141.png": 90881,
	"./personal/avatar/avatar_tsumego_ai_15-kid.png": 84736,
	"./personal/avatar/avatar_tsumego_ai_15.png": 56715,
	"./personal/avatar/avatar_tsumego_ai_16-kid.png": 48459,
	"./personal/avatar/avatar_tsumego_ai_16.png": 3216,
	"./personal/avatar/avatar_tsumego_ai_17-kid.png": 23906,
	"./personal/avatar/avatar_tsumego_ai_17.png": 121,
	"./personal/avatar/avatar_tsumego_ai_18-kid.png": 69037,
	"./personal/avatar/avatar_tsumego_ai_18.png": 10734,
	"./personal/avatar/avatar_tsumego_ai_19-kid.png": 63244,
	"./personal/avatar/avatar_tsumego_ai_19.png": 53751,
	"./personal/avatar/avatar_tsumego_ai_2-kid.png": 80684,
	"./personal/avatar/avatar_tsumego_ai_2.png": 14839,
	"./personal/avatar/avatar_tsumego_ai_20-kid.png": 85612,
	"./personal/avatar/avatar_tsumego_ai_20.png": 38071,
	"./personal/avatar/avatar_tsumego_ai_21-kid.png": 75053,
	"./personal/avatar/avatar_tsumego_ai_21.png": 64430,
	"./personal/avatar/avatar_tsumego_ai_22-kid.png": 10622,
	"./personal/avatar/avatar_tsumego_ai_22.png": 66853,
	"./personal/avatar/avatar_tsumego_ai_23-kid.png": 7319,
	"./personal/avatar/avatar_tsumego_ai_23.png": 49340,
	"./personal/avatar/avatar_tsumego_ai_24-kid.png": 20216,
	"./personal/avatar/avatar_tsumego_ai_24.png": 32947,
	"./personal/avatar/avatar_tsumego_ai_25-kid.png": 7257,
	"./personal/avatar/avatar_tsumego_ai_25.png": 82186,
	"./personal/avatar/avatar_tsumego_ai_26-kid.png": 73786,
	"./personal/avatar/avatar_tsumego_ai_26.png": 31169,
	"./personal/avatar/avatar_tsumego_ai_27-kid.png": 28675,
	"./personal/avatar/avatar_tsumego_ai_27.png": 58456,
	"./personal/avatar/avatar_tsumego_ai_28-kid.png": 22196,
	"./personal/avatar/avatar_tsumego_ai_28.png": 60111,
	"./personal/avatar/avatar_tsumego_ai_29-kid.png": 61973,
	"./personal/avatar/avatar_tsumego_ai_29.png": 91366,
	"./personal/avatar/avatar_tsumego_ai_3-kid.png": 88813,
	"./personal/avatar/avatar_tsumego_ai_3.png": 15342,
	"./personal/avatar/avatar_tsumego_ai_30-kid.png": 23303,
	"./personal/avatar/avatar_tsumego_ai_30.png": 11084,
	"./personal/avatar/avatar_tsumego_ai_31-kid.png": 97134,
	"./personal/avatar/avatar_tsumego_ai_31.png": 63349,
	"./personal/avatar/avatar_tsumego_ai_32-kid.png": 9277,
	"./personal/avatar/avatar_tsumego_ai_32.png": 77598,
	"./personal/avatar/avatar_tsumego_ai_33-kid.png": 68796,
	"./personal/avatar/avatar_tsumego_ai_33.png": 30087,
	"./personal/avatar/avatar_tsumego_ai_34-kid.png": 94227,
	"./personal/avatar/avatar_tsumego_ai_34.png": 50472,
	"./personal/avatar/avatar_tsumego_ai_35-kid.png": 14762,
	"./personal/avatar/avatar_tsumego_ai_35.png": 44337,
	"./personal/avatar/avatar_tsumego_ai_36-kid.png": 37865,
	"./personal/avatar/avatar_tsumego_ai_36.png": 39578,
	"./personal/avatar/avatar_tsumego_ai_37-kid.png": 63432,
	"./personal/avatar/avatar_tsumego_ai_37.png": 87331,
	"./personal/avatar/avatar_tsumego_ai_38-kid.png": 51887,
	"./personal/avatar/avatar_tsumego_ai_38.png": 43460,
	"./personal/avatar/avatar_tsumego_ai_39-kid.png": 91254,
	"./personal/avatar/avatar_tsumego_ai_39.png": 97357,
	"./personal/avatar/avatar_tsumego_ai_4-kid.png": 33626,
	"./personal/avatar/avatar_tsumego_ai_4.png": 30177,
	"./personal/avatar/avatar_tsumego_ai_40-kid.png": 74286,
	"./personal/avatar/avatar_tsumego_ai_40.png": 37973,
	"./personal/avatar/avatar_tsumego_ai_41-kid.png": 28007,
	"./personal/avatar/avatar_tsumego_ai_41.png": 42700,
	"./personal/avatar/avatar_tsumego_ai_42-kid.png": 75004,
	"./personal/avatar/avatar_tsumego_ai_42.png": 93383,
	"./personal/avatar/avatar_tsumego_ai_43-kid.png": 96253,
	"./personal/avatar/avatar_tsumego_ai_43.png": 17598,
	"./personal/avatar/avatar_tsumego_ai_44-kid.png": 2282,
	"./personal/avatar/avatar_tsumego_ai_44.png": 62161,
	"./personal/avatar/avatar_tsumego_ai_45-kid.png": 76211,
	"./personal/avatar/avatar_tsumego_ai_45.png": 13768,
	"./personal/avatar/avatar_tsumego_ai_46-kid.png": 16200,
	"./personal/avatar/avatar_tsumego_ai_46.png": 75747,
	"./personal/avatar/avatar_tsumego_ai_47-kid.png": 4713,
	"./personal/avatar/avatar_tsumego_ai_47.png": 85914,
	"./personal/avatar/avatar_tsumego_ai_48-kid.png": 60982,
	"./personal/avatar/avatar_tsumego_ai_48.png": 55149,
	"./personal/avatar/avatar_tsumego_ai_49-kid.png": 67151,
	"./personal/avatar/avatar_tsumego_ai_49.png": 75556,
	"./personal/avatar/avatar_tsumego_ai_5-kid.png": 16099,
	"./personal/avatar/avatar_tsumego_ai_5.png": 92696,
	"./personal/avatar/avatar_tsumego_ai_50-kid.png": 89881,
	"./personal/avatar/avatar_tsumego_ai_50.png": 72522,
	"./personal/avatar/avatar_tsumego_ai_51.png": 23283,
	"./personal/avatar/avatar_tsumego_ai_52.png": 48792,
	"./personal/avatar/avatar_tsumego_ai_53.png": 21505,
	"./personal/avatar/avatar_tsumego_ai_54.png": 54766,
	"./personal/avatar/avatar_tsumego_ai_55.png": 28407,
	"./personal/avatar/avatar_tsumego_ai_56.png": 39676,
	"./personal/avatar/avatar_tsumego_ai_57.png": 57189,
	"./personal/avatar/avatar_tsumego_ai_58.png": 56322,
	"./personal/avatar/avatar_tsumego_ai_59.png": 19979,
	"./personal/avatar/avatar_tsumego_ai_6-kid.png": 31416,
	"./personal/avatar/avatar_tsumego_ai_6.png": 4659,
	"./personal/avatar/avatar_tsumego_ai_60.png": 80475,
	"./personal/avatar/avatar_tsumego_ai_61.png": 15122,
	"./personal/avatar/avatar_tsumego_ai_62.png": 80265,
	"./personal/avatar/avatar_tsumego_ai_63.png": 3059,
	"./personal/avatar/avatar_tsumego_ai_64.png": 84095,
	"./personal/avatar/avatar_tsumego_ai_65.png": 6006,
	"./personal/avatar/avatar_tsumego_ai_66.png": 96685,
	"./personal/avatar/avatar_tsumego_ai_67.png": 70532,
	"./personal/avatar/avatar_tsumego_ai_68.png": 14403,
	"./personal/avatar/avatar_tsumego_ai_69.png": 9178,
	"./personal/avatar/avatar_tsumego_ai_7-kid.png": 63993,
	"./personal/avatar/avatar_tsumego_ai_7.png": 72746,
	"./personal/avatar/avatar_tsumego_ai_70.png": 35760,
	"./personal/avatar/avatar_tsumego_ai_71.png": 42009,
	"./personal/avatar/avatar_tsumego_ai_72.png": 85922,
	"./personal/avatar/avatar_tsumego_ai_73.png": 7051,
	"./personal/avatar/avatar_tsumego_ai_74.png": 57140,
	"./personal/avatar/avatar_tsumego_ai_75.png": 90173,
	"./personal/avatar/avatar_tsumego_ai_76.png": 92614,
	"./personal/avatar/avatar_tsumego_ai_77.png": 31631,
	"./personal/avatar/avatar_tsumego_ai_78.png": 6680,
	"./personal/avatar/avatar_tsumego_ai_79.png": 27809,
	"./personal/avatar/avatar_tsumego_ai_8-kid.png": 95590,
	"./personal/avatar/avatar_tsumego_ai_8.png": 83517,
	"./personal/avatar/avatar_tsumego_ai_80.png": 16777,
	"./personal/avatar/avatar_tsumego_ai_81.png": 38656,
	"./personal/avatar/avatar_tsumego_ai_82.png": 16987,
	"./personal/avatar/avatar_tsumego_ai_83.png": 2162,
	"./personal/avatar/avatar_tsumego_ai_84.png": 7021,
	"./personal/avatar/avatar_tsumego_ai_85.png": 53124,
	"./personal/avatar/avatar_tsumego_ai_86.png": 89983,
	"./personal/avatar/avatar_tsumego_ai_87.png": 76694,
	"./personal/avatar/avatar_tsumego_ai_88.png": 54001,
	"./personal/avatar/avatar_tsumego_ai_89.png": 60136,
	"./personal/avatar/avatar_tsumego_ai_9-kid.png": 17407,
	"./personal/avatar/avatar_tsumego_ai_9.png": 62388,
	"./personal/avatar/avatar_tsumego_ai_90.png": 92686,
	"./personal/avatar/avatar_tsumego_ai_91.png": 14564,
	"./personal/avatar/avatar_tsumego_ai_92.png": 68252,
	"./personal/avatar/avatar_tsumego_ai_93.png": 20517,
	"./personal/avatar/avatar_tsumego_ai_94.png": 50090,
	"./personal/avatar/avatar_tsumego_ai_95.png": 65651,
	"./personal/avatar/avatar_tsumego_ai_96.png": 70040,
	"./personal/avatar/avatar_tsumego_ai_97.png": 91169,
	"./personal/avatar/avatar_tsumego_ai_98.png": 79654,
	"./personal/avatar/avatar_tsumego_ai_99.png": 44847,
	"./personal/avatar/ladder_b.png": 14320,
	"./personal/avatar/ladder_w.png": 93101,
	"./personal/collection/itp.png": 50469,
	"./personal/crm.png": 71857,
	"./personal/learning-process/handclap-jia.png": 86478,
	"./personal/learning-process/sleep-cat.png": 39108,
	"./personal/report-success.png": 21753,
	"./practice/start.png": 53934,
	"./practice/vs-primary.png": 73220,
	"./practice/vs.png": 73745,
	"./pvp/pvp_lobby_bg.png": 80526,
	"./quick-test/horizontal-logo.png": 6363,
	"./rankTest/home.png": 858,
	"./rankTest/rank.png": 71189,
	"./rankTest/rank0.png": 40657,
	"./rotate-device.png": 10690,
	"./tsume/Atari.png": 75538,
	"./tsume/Bent Four in the Corner.png": 81761,
	"./tsume/Capturing 2.png": 69280,
	"./tsume/Capturing.png": 76378,
	"./tsume/Capturing2.png": 90418,
	"./tsume/Chasing.png": 4118,
	"./tsume/Comprehensive.png": 981,
	"./tsume/Connect and Die.png": 86674,
	"./tsume/Connecting.png": 86803,
	"./tsume/Cutting.png": 5817,
	"./tsume/Double Atari.png": 13321,
	"./tsume/Endgame Tesuji.png": 50164,
	"./tsume/Endgame.png": 78524,
	"./tsume/Eye Destroying.png": 32854,
	"./tsume/Eye Making.png": 7503,
	"./tsume/Fight.png": 62815,
	"./tsume/Illegal Point.png": 21141,
	"./tsume/Ko 2.png": 83365,
	"./tsume/Ko Fight.png": 61997,
	"./tsume/Ko.png": 7463,
	"./tsume/Ko2.png": 6421,
	"./tsume/L-Group.png": 1775,
	"./tsume/Ladder.png": 76853,
	"./tsume/Liberties.png": 35452,
	"./tsume/Life and Death 1.png": 43775,
	"./tsume/Life and Death 2.png": 89124,
	"./tsume/Life and Death 3.png": 29069,
	"./tsume/Life and Death on the Second Line.png": 71248,
	"./tsume/Life and Death.png": 98750,
	"./tsume/Making Live.png": 40298,
	"./tsume/Net.png": 45860,
	"./tsume/Opening Base Stealing.png": 3107,
	"./tsume/Opening Base.png": 54262,
	"./tsume/Opening Techniques.png": 18588,
	"./tsume/Opening.png": 41089,
	"./tsume/Oshi-Tsubushi.png": 89546,
	"./tsume/Probe.png": 72359,
	"./tsume/Rectangle Six.png": 66790,
	"./tsume/Running.png": 50368,
	"./tsume/Seki.png": 51001,
	"./tsume/Tesuji.png": 33652,
	"./tsume/Throw In & Snapback.png": 21357,
	"./tsume/Tiger's Mouth.png": 53615,
	"./verification/IGQE.png": 90616,
	"./verification/info-banner.png": 83991,
	"./weeklyTsume/img_weekly_challenge.png": 74135,
	"./weeklyTsume/img_weekly_challenge_bg.png": 69821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92183;